import { Component, OnDestroy, OnInit, Input, HostListener } from "@angular/core";
import { Router } from "@angular/router";
import { EventService } from "../../shared/services/event.service";
import { ServerService } from "../../shared/services/server.service";
import { IDeveloper, IRegion, IObject, SingleNews } from "../../shared/models/models";
import { Location } from "@angular/common";
import * as moment from "moment";
import { ToastrService } from 'ngx-toastr';


interface IWeek {
  name?: string;
  current?: boolean;
  holiday: boolean;
}



export interface UserInfo {
  firstName: string;
  lastName: string;
  middleName: string;
  mio: IDeveloper[];
  region: IRegion[];
  roles?: string[];
}

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"]
})
export class HeaderComponent implements OnInit, OnDestroy {
  articles: SingleNews[] = [];

  week: IWeek[] = [
    { holiday: false },
    { holiday: false },
    { holiday: false },
    { holiday: false },
    { holiday: false },
    { holiday: true },
    { holiday: true }
  ];

  time: string;
  date: string;
  dateInterval;

  user: UserInfo = null;
  region: IRegion = null;
  userMioName: string[] = [];

  gifUrl = "";
  folderSrc = "/assets/logo/";
  interval;
  index = 0;
  countIsChecked: number = 0;
  newsFlag: boolean;
  mapModal: boolean = false;
  active: string = "";
  portalID: number = 1;
  curators: boolean = false;
  guest: boolean = false;
  videoInstructionModal: boolean = false;

  constructor(
    private router: Router,
    private eventService: EventService,
    private serverService: ServerService,
    private _location: Location,
    public toastr: ToastrService,
  ) {
  }

  ngOnInit() {

    this.active = localStorage.getItem("active");
    if (this.active === null) {
      localStorage.setItem("active", "all");
    }
    let active = localStorage.getItem("active");
    if (active === "all") {
      this.homeBtn = true;
      this.notRealBtn = false;
      this.realBtn = false;
      this.activeLocal = false;
      this.activeLocalForMio = false;
    }
    if (active === "notReal") {
      this.homeBtn = false;
      this.notRealBtn = true;
      this.realBtn = false;
      this.activeLocal = false;
      this.activeLocalForMio = false;
    }
    if (active === "real") {
      this.homeBtn = false;
      this.notRealBtn = false;
      this.realBtn = true;
      this.activeLocal = false;
      this.activeLocalForMio = false;
    }
    let user = localStorage.getItem("user");
    if (user) {
      this.user = JSON.parse(user);
      this.user.mio.map(r => {
        this.userMioName.push(r.title);
      });

      if (this.user.roles.some(e => e === "BDAdmin") ) {
        this.curators = true;
      }

      if (this.user.roles.some(e => e === "AddObjectsAccept")) {
        this.guest = true;
      }

      if (!this.user.roles.some(e => e === "MioAdministrator"))
        this.getCountOfNews();
    }


    this.eventService.chooseRegionEvent.subscribe(id => {
      this.serverService.getRegions().then(response => {
        if (response.length > 0) {
          this.region = response.filter(r => r.id == id)[0];
        }
      });
    });

    this.eventService.count.subscribe(countIsChecked => {
      this.countIsChecked = countIsChecked;
      this.newsFlag = this.countIsChecked > 0 ? true : false;
    });
    let regionModal = localStorage.getItem("regionModal");
    if (!regionModal) {
      if (!this.user.roles.some(e => e === "MioUser")) {
        this.mapModal = true;
        localStorage.setItem("regionModal", "opened");
      }
    }
    this.eventService.openRegionMap.subscribe(bool => {
      this.mapModal = bool;
      this.router.navigate(["/main"]);
    });
  }

  getCountOfNews(): void {
  if(this.user.region.length > 0){
    this.serverService.getNews(this.user.region[0].id).then(res => {
      if (res) {
        res.map(r => {
          this.countIsChecked += r.isChecked == 0 ? 1 : 0;
        });
      }
      this.newsFlag = this.countIsChecked > 0 ? true : false;
    });
  }
  }

  logout() {
    localStorage.clear();
    return this.router.navigate(["/login"]);
  }

  openMapModal() {
    this.mapModal = true;
  }

  goHome() {
    localStorage.setItem("active", "all");
    localStorage.removeItem("lastRegionId");
    localStorage.removeItem("lastCityId");
    localStorage.removeItem("NotReal");
    localStorage.removeItem("Real");
    this.router.navigate(["/login"]);
  }

  goHomeNotReal() {
    localStorage.removeItem("active");
    localStorage.setItem("active", "notReal");
    localStorage.removeItem("lastRegionId");
    localStorage.removeItem("lastCityId");
    localStorage.removeItem("Real");
    localStorage.setItem("Real", "NotReal");
    this.router.navigate(["/login"]);
  }

  goHomeReal() {
    localStorage.removeItem("active");
    localStorage.setItem("active", "real");
    localStorage.removeItem("lastRegionId");
    localStorage.removeItem("lastCityId");
    localStorage.removeItem("NotReal");
    localStorage.setItem("Real", "Real");
    this.router.navigate(["/login"]);
  }
  homeBtn: boolean = false;
  notRealBtn: boolean = false;
  realBtn: boolean = false;
  activeLocal: boolean = false;
  activeLocalForMio: boolean = false;
  object: IObject = null;
  addObject() {

    localStorage.setItem("addobj", "active");
    let respMio = this.user.mio.length == 0 ? { id: null, bin: null, name: "" } : this.user.mio[0];
    this.object = {
      id: 0,
      name: "",
      duration: 0,
      development_start_date: null,
      development_end_date: null,
      region: null,
      city: null,
      finances: null,
      latitude: null,
      longitude: null,
      investments: {
        own_investments: null,
        bd_investments: null,
        own_investments2: null,
        bd_investments2: null,
        implementation_amount: null
      },
      curators: null,
      developer: {
        responsible: respMio,
        general_contractor: null,
        author_supervision: null,
        technical_supervision: null,
        supervisor: null,
        authorized_organization: null
      },
      flatRealization: [],
      spots: [],
      remove_spot_ids: [],
      total_flat_count: 0,
      sales_flat_count: 0,
      completion_percent: 0,
      buildingDocumentsCount: 0,
      portalID: 1,
      bdInvCost_AuthorSuperv: 0,
      bdInvCost_ConstrWork: 0,
      bdInvCost_TechnicalSuperv:0,
      ppInvCost_ConstrWork: 0,
      ppInvCost_TechnicalSuperv: 0,
      ppInvCost_AuthorSuperv: 0,
      bD_FlatArea: 0,
      pP_FlatArea: 0,
      bD_FlatCount: 0,
      pP_FlatCount: 0,
      cadastral: null
    };
    this.homeBtn = false;
    this.notRealBtn = false;
    this.realBtn = false;
    this.activeLocal = true;
    this.activeLocalForMio = false;
    this.serverService.setObject(this.object).then(
      res => {
        this.object.id = res;
        return this.router.navigate(["/main", "object", res, "information"]);
      },
      (err: any) => {

        if (err.status == 500 || err.status == 0) {
          this.toastr.error(
            "К сожалению, сервер временно недоступен. Попробуйте повторить действие чуть позже!",
            "Ваши данные не сохранены!"
          );
        }
      }
    );
    // return this.router.navigate(["/main", "object", 0, "information"]);
  }
  forMio() {
    this.homeBtn = false;
    this.notRealBtn = false;
    this.realBtn = false;
    this.activeLocal = false;
    this.activeLocalForMio = true;
  }

  goBack() {
    this._location.back();
  }

  settingsModal: boolean = false;
  settings() {
    this.settingsModal = true;
  }

  selectedItemIndex: number;
  selectItem(index: number) {
    this.selectedItemIndex = index;
  }

  closeRegionModal() {
    this.mapModal = false;
    // localStorage.removeItem('lastRegionId');
  }

  // division(selectedValue) {
  //   if(selectedValue === 1) {
  //     localStorage.setItem("objects", "mio");
  //     return this.router.navigate(["/"]);
  //   }
  //   if(selectedValue === 2) {
  //     localStorage.setItem("objects", "bd");
  //     return this.router.navigate(["/"]);
  //   }
  // }

  // @HostListener('window:beforeunload')
  ngOnDestroy() {
    clearInterval(this.dateInterval);
  }

}
